
//pagina com titulo SERVICES & PRICES e um paragrafo falando sobre os serviços e preços da empresa e o que a empresa oferece, e uma imagem relacionada a serviços e preços
import React from 'react';
import logo from '../assets/logoSF.png';
import '../styles/global.css';
import { Done, Block, Info } from '@mui/icons-material';
import { Link } from 'react-router-dom';

function Services() {
    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div className='headerMain'>
                    <div>
                        <div>
                            <label>Services & Prices</label>
                        </div>
                    </div>
                </div>
                {/* <hr /> */}
                <div>
                    <div className='pr8 pl8 text-align-left'>
                        <div className='mt2 text-align-left'>
                            <label style={{ fontWeight: '800' }} className='labelTitulo' >FOR INDIVIDUALS</label>
                        </div>
                        <div className='mt1 text-align-left'>
                            <label className='labelTitulo'>Tax return Form 1040: starting at $75.00, plus $25 for any state tax return.</label>
                        </div>
                    </div>
                    {/* what is included */}
                    <div className='pr8 pl8 text-align-left'>
                        <div className='mt3 mb1 text-align-left'>
                            <label style={{ fontWeight: '800' }} className='labelTitulo' >WHAT <span style={{ color: 'green' }}>IS</span> INCLUDED</label>
                        </div>
                        <div className='mt1'>
                            <Done style={{ color: 'green', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Income from W-2</label> 
                        </div>
                        <div className='mt1'>
                            <Done style={{ color: 'green', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Standard Deduction Only</label>
                        </div>
                        <div className='mt1'>
                            <Done style={{ color: 'green', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Income from interest and dividends (Form 1099-INT and Form 1099-DIV) less than $1,500, in which no require Schedule B or Form 8949</label>
                        </div>
                        <div className='mt1'>
                            <Done style={{ color: 'green', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Eligibility for Earned Income Tax Credit (EITC)</label>
                        </div>
                        <div className='mt1'>
                            <Done style={{ color: 'green', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Eligibility for Child Tax Credit (CTC)</label>
                        </div>
                        <div className='mt1'>
                            <Done style={{ color: 'green', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Claim deduction for student loan interest</label>
                        </div>
                        <div className='mt1'>
                            <Done style={{ color: 'green', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Claim deductions for tips, overtime pay, car loan interest, and seniors above 65 (Schedule 1-A)</label>
                        </div>
                        <div className='mt1'>
                            <Done style={{ color: 'green', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Taxable retirement account distributions (Form 1099-R)</label>
                        </div>
                        <div className='mt1'>
                            <Done style={{ color: 'green', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Premium Tax Credit Health Insurance Marketplace (Form 1095-A)</label>
                        </div>
                        <div className='mt1'>
                            <Done style={{ color: 'green', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Social Security Benefits (Form SSA-1099)</label>
                        </div>
                        <div className='mt1'>
                            <Done style={{ color: 'green', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Qualified tuition, fees, and scholarships (Form 1098-T)</label>
                        </div>
                        <div className='mt1'>
                            <Done style={{ color: 'green', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Unemployment income (Form 1099-G)</label>
                        </div>
                    </div>
                    {/* what is not included */}
                    <div className='pr8 pl8 text-align-left'>
                        <div className='mt3 mb1 text-align-left'>
                            <label style={{ fontWeight: '800' }} className='labelTitulo'  >WHAT IS <span style={{ color: 'red' }}>NOT</span> INCLUDED</label>
                        </div>
                        <div className='mt1'>
                            <Block style={{ color: 'red', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Itemized deductions such as charitable contributions, medical expenses, mortgage interest and SALT (Schedule A)</label>
                        </div>
                        <div className='mt1'>
                            <Block style={{ color: 'red', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Self-employment income of sole proprietors, independent contractors, gig workers or freelance reported on 1099-NEC</label>
                        </div>
                        <div className='mt1'>
                            <Block style={{ color: 'red', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Income and expenses from a business (Schedule C) or from farm activities (Schedule F)</label>
                        </div>
                        <div className='mt1'>
                            <Block style={{ color: 'red', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Income from rental properties reported on Schedule E or property sales reported on Form 8949</label>
                        </div>
                        <div className='mt1'>
                            <Block style={{ color: 'red', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Partner's, shareholder's, or beneficiary's share of income, losses, deductions, and credits reported on Schedule K-1</label>
                        </div>
                        <div className='mt1'>
                            <Block style={{ color: 'red', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Capital gains and losses from sale of stocks, bonds, or other capital assets, including criptocurrency informed on Form 1099-DA (Schedule D)</label>
                        </div>
                        <div className='mt1'>
                            <Block style={{ color: 'red', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Foreign earned income exclusion or foreign housing deduction (Form 2555)</label>
                        </div>
                        <div className='mt1'>
                            <Block style={{ color: 'red', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Credit for taxes paid on foreign-sourced income (Form 1116)</label>
                        </div>
                        <div className='mt1'>
                            <Block style={{ color: 'red', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Foreign financial accounts (FBAR FinCEN Form 114)</label>
                        </div>
                        <div className='mt1'>
                            <Block style={{ color: 'red', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent'>Interests in foreign financial assets (FATCA Form 8938)</label>
                        </div>
                        <div className='mt2'>
                            <Info style={{ color: 'orange', width: '32px', height: '32px', marginRight: '8px', marginBottom: '-5px' }} />
                            <label className='labelContent' style={{ fontWeight: 'bold' }}>Those items and other forms or schedules will be charged based on hourly rate of $75.00 per hour or a flat fee depending on the complexity of the tax return. Please contact us for a free consultation and an estimate of the total cost of your tax return preparation.</label>
                        </div>
                        
                    </div>
                    {/* for small business */}
                    <div className='pr8 pl8 text-align-left'>
                        <div className='mt3 text-align-left'>
                            <label style={{ fontWeight: '800' }} className='labelTitulo' >FOR SMALL BUSINESS</label>
                        </div>
                        <div className='mt1 text-align-left'>
                             <label className='labelContent'>Please contact us for a free consultation and an estimate of the total cost of your tax return preparation for small business.</label>
                        </div>
                        <div className='mt1 text-align-left'>
                            <label className='labelContent'>Defined as business with total income receipts less than $250K a year and assets less than $1 million</label>
                        </div>
                        <div className='mt1 text-align-left'>
                            <label className='labelContent'>Tax Returns:</label>
                        </div>
                        <div className='mt1 text-align-left'>
                            <label className='labelContent'>1. For Partnerships (Form 1065): $250.00</label>
                        </div>
                        <div className='mt1 text-align-left'>
                            <label className='labelContent'>2. For Corporations (Form 1120): $350.00</label>
                        </div>
                        <div className='mt1 text-align-left'>
                            <label className='labelContent'>3. For S-Corporations (Form 1120-S): $400.00</label>
                        </div>
                        <div className='mt1 text-align-left'>
                            <label className='labelContent'>Other services:</label>
                        </div>
                        <div className='mt1 text-align-left'>
                            <label className='labelContent'>4. Set up LLC or Corporation (Florida Sunbiz and EIN): $150.00</label>
                        </div>
                        <div className='mt1 text-align-left'>
                            <label className='labelContent'>5. Florida Business Tax Application (Sale Tax): $100.00</label>
                        </div>
                        <div className='mt1 text-align-left'>
                            <label className='labelContent'>6. Annual Report in Florida: $70 plus Sunbiz fees</label>
                        </div>
                    </div>
                </div>
                <div className='w100 text-align-center labelTitulo'>
                    <Link to="/contact" style={{ textDecoration: 'none' }}>
                        <button className='btnContact mt4 mb4 p1' style={{ textDecoration: 'none', fontSize: '32px', cursor: 'pointer' }}>CONTACT US FOR A FREE CONSULTATION</button>
                    </Link>
                </div>
            
            </main>
        </div>
    );
}

export default Services;